import { Routes, Route } from 'react-router-dom';
import Navigation from './components/layout/Navigation';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import HowWeWork from './pages/HowWeWork';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import MemoriaAccountDeletion from './pages/MemoriaAccountDeletion';
import RankfulAccountDeletion from './pages/RankfulAccountDeletion';
import DrewnikaAccountDeletion from './pages/DrewnikaAccountDeletion';
import DrewnikaPrivacy from './pages/DrewnikaPrivacy';
import NotFound from './pages/NotFound';
import './App.scss';

function App() {
  return (
    <div className="app">
      <Navigation />
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/how-we-work" element={<HowWeWork />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/memoria/account-deletion-request" element={<MemoriaAccountDeletion />} />
          <Route path="/rankful/account-deletion-request" element={<RankfulAccountDeletion />} />
          <Route path="/drewnika/privacy" element={<DrewnikaPrivacy />} />
          <Route path="/drewnika/account-deletion-request" element={<DrewnikaAccountDeletion />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
